export const ERROR = 'error'
export const WARNING = 'warning'
